import uuid from 'uuid';

import LocalStorage, { StorageKeys } from 'utils/local-storage';

/**
 * The identity a signed-out guest is bucketed on.
 *
 * A percentage rollout hashes the targeting key, so the key has to outlive
 * the page: one minted per load re-rolls the dice on every visit, and a guest
 * would see a flag come and go rather than be inside or outside a rollout.
 *
 * This is browser-scoped by construction and is not, and cannot be, the same
 * value the app uses for a signed-out guest — see the targeting-key note in
 * `evaluation-context.ts`.
 */
export const getDatadogFlagsAnonymousId = (): string => {
  const stored = LocalStorage.getItem<string>(StorageKeys.DATADOG_FLAGS_ANONYMOUS_ID);

  if (stored) {
    return stored;
  }

  const minted = uuid();
  LocalStorage.setItem(StorageKeys.DATADOG_FLAGS_ANONYMOUS_ID, minted);

  return minted;
};
